import { useEffect } from 'react';
import { notification } from 'antd';
import {
  SendOutlined,
  ClockCircleOutlined,
  UserSwitchOutlined,
} from '@ant-design/icons';
import { useNotifications } from '../../contexts/NotificationContext';
import { RecommendedAction } from '../../types';

const actionIcons: Record<RecommendedAction, React.ReactNode> = {
  reply_needed: <SendOutlined style={{ color: '#d97706' }} />,
  follow_up_suggested: <ClockCircleOutlined style={{ color: '#207551' }} />,
  retry_different_contact: <UserSwitchOutlined style={{ color: '#7c3aed' }} />,
};

const RecommendedActionNotifier: React.FC = () => {
  const { subscribe } = useNotifications();

  useEffect(() => {
    return subscribe(['recommended_action_changed'], (event) => {
      const { metadata } = event;
      const newAction = metadata?.newAction as RecommendedAction | null;

      // Don't toast when action is cleared — the user just took the action themselves
      if (!newAction) return;

      notification.info({
        message: event.title,
        description: event.message,
        placement: 'topRight',
        duration: 8,
        icon: actionIcons[newAction],
      });
    });
  }, [subscribe]);

  return null;
};

export default RecommendedActionNotifier;
